export default[
    {
        path: '/certificado/lista',
        name: 'lista certicado', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/certificado/cadastro',
        name: 'cadastro certificado', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/certificado/editar/:id',
        name: 'editar certificado', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]